export default "__VITE_ASSET__1448b69d__"